import {
  HeadlineOne,
  HeadlineTwo,
  Paragraph,
  SectionWrapper,
} from 'components/atoms/SectionWrapper.style';
import React from 'react';
import styled from 'styled-components';
import { cms } from 'assets/cms';
import GoogleApiWrapper from 'components/organisms/formComponents/maps/Maps';
import Map from 'components/organisms/formComponents/map/Map';
import MapsMain from './MapMain';

const ContactWrapper = styled.div`
  display: flex;
  /* margin-top: 50px; */
  flex-direction: column;
  justify-content: center;
  margin-bottom: 120px;

  @media ${({ theme }) => theme.media.mobile} {
    display: flex;
    /* flex-direction: column; */
    /* justify-content: space-evenly; */
    align-items: center;
  }

  @media ${({ theme }) => theme.media.tablet} {
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
  }
`;

// const MapsWrapper = styled.div`
//   border: 1px solid black;
//   width: 250px;
//   height: 150px;
//   background: violet;
//   background: url(${cms.images.maps});
//   background-size: contain;

//   @media ${({ theme }) => theme.media.tablet} {
//     width: 550px;
//     height: 250px;
//   }
// `;

const LeftWrapper = styled.div`
  width: 100%;
  height: 210px;
  margin-left: 80px;

  @media ${({ theme }) => theme.media.tablet} {
    width: 30%;
    height: 330px;
  }
`;
const RightWrapper = styled.div`
  width: 110%;
  margin-top: 100px;
  /* height: 300px; */
  /* @media ${({ theme }) => theme.media.mobile} {
    margin-top: 50px;
  } */
  @media ${({ theme }) => theme.media.tablet} {
    width: 70%;
    /* height: 330px; */
    /* margin-top: 0; */
  }
`;

const Space = styled.div`
  height: 30px;
`;

const MapsGoogleWrapper = styled.div`
  margin-top: 70px;
`;

const Contact = () => (
  <>
    <SectionWrapper>
      <ContactWrapper>
        <LeftWrapper>
          <HeadlineOne>Kontakt</HeadlineOne>

          <HeadlineTwo>ELGREEN PROJEKT Sp. z o.o.</HeadlineTwo>
          <Paragraph>Łąkowa 76 , 81-577 Gdynia</Paragraph>
          <Paragraph>535-061-637</Paragraph>
          <Paragraph>elgreen@elgreen.pl</Paragraph>
          <Space />
          <HeadlineTwo>Biuro:</HeadlineTwo>
          <Paragraph>Rdestowa 51, 84-240 Reda</Paragraph>
          <Paragraph>535-061-637</Paragraph>
          <Paragraph>elgreen@elgreen.pl</Paragraph>
        </LeftWrapper>
        <RightWrapper>
          <MapsMain />
        </RightWrapper>
      </ContactWrapper>
      <Space />
      <Space />
      <Space />
    </SectionWrapper>
  </>
);

export default Contact;
